/* global DetailsModal, CompareUtil */

customElements.whenDefined('details-modal').then(() => {
  class CompareModal extends DetailsModal {
    constructor() {
      super();
      this.compareContainer = this.querySelector('.compare-container');
      this.compareArea = this.compareContainer.querySelector('.js-compare-area');
      this.loadingSpinner = this.compareContainer.querySelector('.loading-spinner');
      this.closeButton = this.querySelectorAll('.js-compare-close');

      this.bindEvents();
    }

    disconnectedCallback() {
      document.removeEventListener('focusin', this.clickHandler);

      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:load', CompareModal.handleSectionChange);
        document.removeEventListener('on:product-compare:reload', this.compareReloadHandler);
      }
    }

    bindEvents() {
      this.addEventListener('on:product-compare-modal:open', this.open);

      this.clickHandler = this.handleClick.bind(this);
      document.addEventListener('click', this.clickHandler);

      this.closeButton.forEach((closeButton) => {
        closeButton.addEventListener('click', this.close.bind(this));
      });

      // Refresh the compare when the Compare section get updated
      if (Shopify.designMode) {
        this.compareReloadHandler = this.renderCompareTable.bind(this);
        document.addEventListener('shopify:section:load', CompareModal.handleSectionChange);
        document.addEventListener('on:product-compare:reload', this.compareReloadHandler);
      }
    }

    /**
     * Handles a 'click' event for remove from compare
     * @param {object} evt - Event object
     */
    handleClick(evt) {
      const removeBtn = evt.target.closest('.js-compare-col-remove');
      if (!removeBtn) return;

      evt.preventDefault();

      const productId = removeBtn.dataset.productId;
      if (!productId) return;

      CompareUtil.removeFromCompare(productId.toString(), true);

      const compareCount = CompareUtil.getCompareCount();
      this.compareContainer.dataset.compareCount = compareCount;

      if (compareCount < 2) {
        this.close();
        return;
      }

      this.renderCompareTable();
    }

    /**
     * Opens the compare modal
     */
    open() {
      this.modal.classList.remove('hidden');
      this.renderCompareTable();
      super.open();
    }

    /**
     * Hook into the super function to hide the modal when it's finished closing
     * @param {object} evt - Event object
     */
    handleTransitionEnd(evt) {
      super.handleTransitionEnd(evt);
      if (this.modal.open === false) {
        this.modal.classList.add('hidden');
      }
    }

    static getCompareLabelIcons() {
      return {
        price: `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.32695 0.198432C7.26303 0.135019 7.18722 0.0848489 7.10386 0.0507995C7.02051 0.0167501 6.93126 -0.000509175 6.84123 1.14361e-05H0.684123C0.307855 1.14361e-05 0 0.307906 0 0.684221V6.84211C0 7.02685 0.0752535 7.1979 0.198396 7.3279L5.67138 12.8016C5.8082 12.9384 5.97923 13 6.1571 13C6.33497 13 6.50601 12.9316 6.64283 12.8016L12.7999 6.64369C12.8634 6.58039 12.9137 6.5052 12.948 6.42243C12.9823 6.33966 13 6.25093 13 6.16132C13 6.07171 12.9823 5.98298 12.948 5.90021C12.9137 5.81744 12.8634 5.74225 12.7999 5.67895L7.32695 0.198432ZM6.1571 11.3442L1.36825 6.55474V1.36159H6.56074L11.3496 6.15106L6.1571 11.3442Z" fill="#910039"/><path d="M4.10474 2.73685C3.34536 2.73685 2.73649 3.35264 2.73649 4.10527C2.73649 4.8579 3.3522 5.47369 4.10474 5.47369C4.85727 5.47369 5.47298 4.8579 5.47298 4.10527C5.47298 3.35264 4.85727 2.73685 4.10474 2.73685Z" fill="#910039"/></svg>`,
        description: `<svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.75C0 0.551088 0.0790176 0.360322 0.21967 0.21967C0.360322 0.0790175 0.551088 0 0.75 0H15.25C15.4489 0 15.6397 0.0790175 15.7803 0.21967C15.921 0.360322 16 0.551088 16 0.75C16 0.948912 15.921 1.13968 15.7803 1.28033C15.6397 1.42098 15.4489 1.5 15.25 1.5H0.75C0.551088 1.5 0.360322 1.42098 0.21967 1.28033C0.0790176 1.13968 0 0.948912 0 0.75ZM0 5C0 4.80109 0.0790176 4.61032 0.21967 4.46967C0.360322 4.32902 0.551088 4.25 0.75 4.25H15.25C15.4489 4.25 15.6397 4.32902 15.7803 4.46967C15.921 4.61032 16 4.80109 16 5C16 5.19891 15.921 5.38968 15.7803 5.53033C15.6397 5.67098 15.4489 5.75 15.25 5.75H0.75C0.551088 5.75 0.360322 5.67098 0.21967 5.53033C0.0790176 5.38968 0 5.19891 0 5ZM0.75 8.5C0.551088 8.5 0.360322 8.57902 0.21967 8.71967C0.0790176 8.86032 0 9.05109 0 9.25C0 9.44891 0.0790176 9.63968 0.21967 9.78033C0.360322 9.92098 0.551088 10 0.75 10H10.25C10.4489 10 10.6397 9.92098 10.7803 9.78033C10.921 9.63968 11 9.44891 11 9.25C11 9.05109 10.921 8.86032 10.7803 8.71967C10.6397 8.57902 10.4489 8.5 10.25 8.5H0.75Z" fill="#910039"/></svg>`,
        comfort: `<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.1504 0.75C11.9418 0.750187 13.25 2.03843 13.25 3.59668C13.25 4.56564 12.7891 5.516 11.7949 6.65234C10.7945 7.7958 9.3482 9.02441 7.53027 10.5645L7.5293 10.5654L7 11.0146L6.4707 10.5654L6.46973 10.5645C4.6518 9.02441 3.20554 7.7958 2.20508 6.65234C1.21086 5.516 0.75 4.56564 0.75 3.59668C0.750028 2.03843 2.05823 0.750187 3.84961 0.75C4.85897 0.75 5.82731 1.19264 6.44727 1.86719L7 2.46875L7.55273 1.86719C8.17269 1.19264 9.14103 0.75 10.1504 0.75Z" stroke="#910039" stroke-width="1.5"/></svg>`,
        weight: `<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 3C5 3.53043 5.21071 4.03914 5.58579 4.41421C5.96086 4.78929 6.46957 5 7 5C7.53043 5 8.03914 4.78929 8.41421 4.41421C8.78929 4.03914 9 3.53043 9 3C9 2.46957 8.78929 1.96086 8.41421 1.58579C8.03914 1.21071 7.53043 1 7 1C6.46957 1 5.96086 1.21071 5.58579 1.58579C5.21071 1.96086 5 2.46957 5 3Z" stroke="#910039" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.02802 5H10.972C11.1521 4.99997 11.3265 5.05973 11.4648 5.16885C11.6031 5.27796 11.6965 5.42952 11.7287 5.59709L12.9876 12.1425C13.0077 12.2474 13.0033 12.3551 12.9746 12.4581C12.9459 12.5611 12.8936 12.6569 12.8214 12.7387C12.7492 12.8205 12.6589 12.8863 12.5569 12.9315C12.4548 12.9766 12.3435 13 12.2309 13H1.76913C1.65648 13 1.54519 12.9766 1.44315 12.9315C1.34111 12.8863 1.2508 12.8205 1.17861 12.7387C1.10643 12.6569 1.05412 12.5611 1.02541 12.4581C0.996688 12.3551 0.992255 12.2474 1.01242 12.1425L2.2713 5.59709C2.30354 5.42952 2.39695 5.27796 2.53523 5.16885C2.67352 5.05973 2.84792 4.99997 3.02802 5Z" stroke="#910039" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        size: `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.5768 2.4359L2.43578 11.5767H4.32624C4.41968 11.5767 4.51222 11.5951 4.59855 11.6309C4.68488 11.6666 4.76332 11.7191 4.8294 11.7851C4.89547 11.8512 4.94789 11.9297 4.98365 12.016C5.01941 12.1023 5.03781 12.1948 5.03781 12.2883C5.03781 12.3817 5.01941 12.4743 4.98365 12.5606C4.94789 12.6469 4.89547 12.7254 4.8294 12.7914C4.76332 12.8575 4.68488 12.9099 4.59855 12.9457C4.51222 12.9814 4.41968 12.9998 4.32624 12.9998H0.76905L0.743735 12.9995C0.646106 13.0031 0.548779 12.9865 0.457877 12.9508C0.366974 12.915 0.284461 12.8607 0.215528 12.7915C0.0961327 12.6725 0.0231075 12.5148 0.0095814 12.3468C0.00310087 12.3085 -0.000103634 12.2697 2.55458e-06 12.2308V8.67369C2.55458e-06 8.48498 0.0749717 8.30399 0.208418 8.17054C0.341864 8.0371 0.522856 7.96213 0.711577 7.96213C0.900298 7.96213 1.08129 8.0371 1.21474 8.17054C1.34818 8.30399 1.42315 8.48498 1.42315 8.67369V10.5781L10.5778 1.42295H8.67369C8.57895 1.42503 8.48475 1.40816 8.39662 1.37335C8.30849 1.33853 8.22821 1.28646 8.16047 1.2202C8.09274 1.15393 8.03892 1.07481 8.00218 0.987464C7.96544 0.90012 7.94651 0.806318 7.94651 0.711561C7.94651 0.616805 7.96544 0.523002 8.00218 0.435659C8.03892 0.348315 8.09274 0.26919 8.16047 0.202926C8.22821 0.136661 8.30849 0.0845928 8.39662 0.0497756C8.48475 0.0149583 8.57895 -0.00190649 8.67369 0.000171059H12.2309C12.2706 0.000171059 12.3093 0.00336392 12.3472 0.00974973C12.509 0.0227494 12.6674 0.0915109 12.7916 0.215692C12.937 0.360741 13.0061 0.553342 12.9996 0.743889L12.9999 0.769205V4.32633C12.9999 4.51504 12.925 4.69603 12.7915 4.82948C12.6581 4.96292 12.4771 5.03789 12.2883 5.03789C12.0996 5.03789 11.9186 4.96292 11.7852 4.82948C11.6517 4.69603 11.5768 4.51504 11.5768 4.32633V2.4359Z" fill="#910039"/></svg>`
      };
    }

    static getIconForRowKey(rowKey) {
      if (rowKey === 'compare-price') return 'price';
      if (rowKey === 'compare-variants') return 'size';
      if (rowKey === 'compare-description') return 'description';
      if (rowKey.startsWith('compare-metafield')) return 'none';
      return 'none';
    }

    static getIconFromLabelText(labelText) {
      const normalized = (labelText || '').toLowerCase();
      if (normalized.includes('preço') || normalized.includes('preco')) return 'price';
      if (normalized.includes('descritivo') || normalized.includes('descrição') || normalized.includes('descricao')) {
        return 'description';
      }
      if (normalized.includes('conforto')) return 'comfort';
      if (normalized.includes('peso')) return 'weight';
      if (normalized.includes('tamanho') || normalized === 'title') return 'size';
      return 'none';
    }

    static getLabelTextForRowKey(rowKey) {
      return rowKey.replace('compare-', '').replace(/-/g, ' ').replace('metafield ', '');
    }

    static buildLabelHtml(iconKey, labelText) {
      const icons = CompareModal.getCompareLabelIcons();
      const icon = icons[iconKey];
      const iconMarkup = icon
        ? `<span class="compare-label__icon" aria-hidden="true">${icon}</span>`
        : '';

      return `<div class="compare-label compare-label--with-icon" data-compare-label-icon="${iconKey}">${iconMarkup}<span class="compare-label__text">${labelText}</span></div>`;
    }

    /**
     * Triggers a refresh the compare table based on Theme Editor events
     * @param {object} evt - Event object
     */
    static handleSectionChange(evt) {
      if (evt.target.matches('.cc-compare')) {
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('on:product-compare:reload'));
        }, 1000);
      }
    }

    /**
     * Renders the compare table
     */
    async renderCompareTable() {
      // Reset the previous state if applicable
      this.loadingSpinner.removeAttribute('hidden');
      this.loadingSpinner.removeAttribute('aria-hidden');
      this.compareArea.classList.remove('revealable--in');
      this.compareArea.innerHTML = '';

      // Get the compare products
      const compareProducts = CompareUtil.getSelectedProducts();
      if (compareProducts) {
        this.compareContainer.dataset.compareCount = compareProducts.length;

        // Transform the HTML into something flexbox friendly
        const compareProductHtmlArr = await CompareModal.getCompareProducts(compareProducts);
        const compareFieldsArr = [];

        if (compareProductHtmlArr.length > 0) {
          compareProductHtmlArr.forEach((compareProductHtml) => {
            const responseHTML = document.implementation.createHTMLDocument();
            responseHTML.documentElement.innerHTML = compareProductHtml; // eslint-disable-line

            responseHTML.querySelectorAll('.shopify-section > div').forEach((compareField) => {
              if (!compareFieldsArr[compareField.dataset.compareKey]) {
                compareFieldsArr[compareField.dataset.compareKey] = [];
              }
              compareFieldsArr[compareField.dataset.compareKey].push(compareField);
            });
          });

          // Create the compare flex
          const compareElem = document.createElement('div');
          compareElem.className = 'compare-temp';

          Object.entries(compareFieldsArr).forEach(([key, value]) => {
            // If we can show empty metafield rows, or all metafields are not empty
            if (theme.settings.compareShowEmptyMetafields
              || !value.every((elem) => !!elem.dataset.isEmptyMetafield)) {
              const compareRow = document.createElement('div');
              const isCard = key.includes('product_card');
              compareRow.className = `compare-row compare-row--${
                key.includes('metafield') ? 'metafield' : key.replace('compare-', '')
              }${isCard ? ' compare-row--card' : ''}`;

              // Add Label Cell
              const labelCell = document.createElement('div');
              labelCell.className = 'compare-label-cell';

              const firstField = value[0];
              const labelEl = firstField.querySelector('.compare-label');

              if (labelEl) {
                labelCell.innerHTML = labelEl.outerHTML;
                value.forEach((field) => {
                  const lbl = field.querySelector('.compare-label');
                  if (lbl) lbl.remove();
                });
              } else if (isCard) {
                labelCell.innerHTML = '';
              } else {
                labelCell.innerHTML = CompareModal.buildLabelHtml(
                  CompareModal.getIconForRowKey(key),
                  CompareModal.getLabelTextForRowKey(key)
                );
              }
              
              compareRow.appendChild(labelCell);

              value.forEach((elem) => compareRow.appendChild(elem));
              compareElem.appendChild(compareRow);
            }
          });

          this.compareArea.innerHTML = '';
          this.compareArea.appendChild(compareElem);

          if (window.CompareCardVariant) {
            window.CompareCardVariant.init(this.compareArea);
          }
        } else {
          this.compareArea.innerHTML = `Unable to compare products.${
            Shopify.designMode
              ? ' Ensure the Product Compare section is enabled.'
              : ' Please try again later.'
          }`;
        }

        // Timeout to trigger CSS transition
        setTimeout(() => {
          this.loadingSpinner.setAttribute('hidden', 'true');
          this.loadingSpinner.setAttribute('aria-hidden', 'true');
          this.compareArea.classList.add('revealable--in');
        }, 100);
      }
    }

    /**
     * Fetches an array of html for each of the compare products, using the section rendering API
     * @param {Array} compareProducts - An array of product objects to compare
     */
    static async getCompareProducts(compareProducts) {
      const tempHtml = [];
      await Promise.all(
        compareProducts.map(async (product) => {
          try {
            const response = await fetch(`${product.url}`);
            if (response.ok) {
              const tmpl = document.createElement('template');
              tmpl.innerHTML = await response.text();
              const compareEl = tmpl.content.querySelector('.cc-compare');

              if (compareEl) {
                // Remove the inner template tag
                const templateEl = compareEl.querySelector('template');
                if (templateEl) {
                  const templateContent = document.importNode(templateEl.content, true);
                  templateEl.parentNode.insertBefore(templateContent, templateEl);
                  templateEl.remove();
                }
                tempHtml[product.id] = compareEl.outerHTML;
              } else {
                console.warn(`Compare: Product ${product.id} does not have .cc-compare section`);
              }
            } else {
              console.warn(`Compare: Failed to fetch product ${product.id} - ${response.status}`);
            }
          } catch (error) {
            console.error(`Compare: Error fetching product ${product.id}:`, error);
          }
        })
      );

      // Return the html in the order they were added to the compare
      const returnHtml = [];
      if (Object.keys(tempHtml).length > 0) {
        compareProducts.forEach((product) => {
          if (tempHtml[product.id]) {
            returnHtml.push(tempHtml[product.id]);
          }
        });
      }

      return returnHtml;
    }
  }

  customElements.define('compare-modal', CompareModal);
});
